import { action, computed, makeObservable, observable } from 'mobx';
import { httpRequest } from '@/request';
import { SERVER } from '@/request/config';
import { message } from 'antd';
import { handleQueryParams, isEmpty, LANG } from '@/utils';
import StoreBase from './Base';

class Reseller extends StoreBase {
  constructor(props) {
    super(props);
    makeObservable(this);
  }

  /**
   * @description 个人分销商申请信息
   * state: -1未通过审核：0待审核；1已审核；2已选择产品；9已成为分销商 ；-3应该是古早时期前端定义的数值，因为前后端代码都查无数值定义
   *
   */
  @observable
  individual = {
    state: -3,
    type: 'individual',
    apply_info: {},
  };

  // 分销商信息
  @observable
  resellerUserInfo = {};

  // 是否同意更新协议，0默认初始，不知道是否同意，1同意，2不同意
  @observable
  isUpdateAgreement = 1;

  @computed
  get isIndividualReseller() {
    return this.resellerUserInfo?.type === 'individual';
  }

  @action
  setStateValue = (key, value) => {
    this[key] = value;
  };
  /*
   *
   * @desc: 验证是否为分销商
   * @author: haifn
   * @time: 2021-11-22 7:0:24
   */
  @action
  verifyReseller = () => {
    const url = SERVER.API_SERVER_RESELLER + '/info/isReseller';
    return httpRequest({
      url,
      instaToken: true,
    });
  };

  // 获取分销商推广链接列表
  @action
  getLinks = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/promo/getLinks';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        callback && callback(res.data.links);
        return;
      }
      callback && callback([]);
    });
  };

  @action
  setCurrencyChoice = (values) => {
    const url = SERVER.API_SERVER_RESELLER + '/info/setCommissionCurrency';
    httpRequest({
      url,
      data: values,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        message.success(LANG['common.tips.submittedSuccessfully']);
        window.location.href = handleQueryParams();
      }
    });
  };

  @action
  getStrategy = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/listResellerExtension';
    return httpRequest({
      url,
      instaToken: true,
      params: {
        page_number: 1,
        page_size: 20,
      },
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  @action
  getResellerApply = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/apply/getApplyInfo';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (res.data.individual_apply) {
          const tempData = res.data.individual_apply;
          if (tempData?.apply_info) {
            tempData.apply_info = JSON.parse(tempData.apply_info);
            this.individual = tempData;
          }
          this.getResellerInfo();
        }
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  @action
  addWithdrawAccount = (values, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/createWithdrawAccount';
    httpRequest({
      url,
      data: values,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.withdrawAccount);
        }
        message.success(LANG['common.tips.submittedSuccessfully']);
      }
    });
  };

  @action
  applyWithdraw = (values, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/applyWithdraw';
    httpRequest({
      url,
      data: values,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
        message.success(LANG['common.tips.submittedSuccessfully']);
      } else {
        message.error(LANG['common.tips.submittedFailed']);
      }
    });
  };

  @action
  getResellerInfo = (callback) => {
    const { instaStorage } = this.root.app;
    let resellerInfo = instaStorage.get('reseller_info', { type: 'object' });
    if (!isEmpty(resellerInfo) && resellerInfo.use_currency) {
      this.resellerUserInfo = resellerInfo;
      callback && callback(resellerInfo);
      return;
    }
    const url = SERVER.API_SERVER_RESELLER + '/info/getResellerInfo';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        instaStorage.set('reseller_info', res.data.reseller);
        this.resellerUserInfo = res.data.reseller;
        callback && callback(res.data);
      } else {
        callback && callback({});
      }
    });
  };

  @action
  applyReseller = (data, cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/apply/submitApplyInfo';
    this.root.app.setGlobalValue('G_GlobalLoading', true);
    httpRequest({
      url,
      data: {
        ...data,
        check: true,
      },
      method: 'post',
      instaToken: true,
    })
      .then((res) => {
        this.root.app.setGlobalValue('G_GlobalLoading', false);
        if (res.code === 0) {
          if (cb) {
            cb();
          }
        }
        if (res.code === -1 && res.error === 'TB Resp Err') {
          if (cb) {
            cb();
          }
        }
      })
      .catch(() => {
        this.root.app.setGlobalValue('G_GlobalLoading', false);
      });
  };

  @action
  getResellerIncome = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/info/getCommission';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        callback && callback(res.data);
      }
    });
  };

  // 获取总的提现数据列表
  @action
  listWithdraw = (params, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/listWithdrawPage';
    httpRequest({
      url,
      instaToken: true,
      params,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  // 获取当前用户的提现账户列表
  @action
  listWithdrawAccount = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/listWithdrawAccount';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.withdrawAccounts);
        }
      }
    });
  };

  // 获取可提现订单数据
  @action
  listWithdrawalOrderApply = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/order/listWithdrawalOrderApply';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  @action
  updateWithdrawAccount = (values, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/updateWithdrawAccount';
    httpRequest({
      url,
      data: values,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.withdraw_account);
        }
        message.success(LANG['common.tips.submittedSuccessfully']);
      }
    });
  };

  @action
  deleteWithdrawAccount = (values, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/withdraw/deleteWithdrawAccount';
    httpRequest({
      url,
      data: values,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
        message.success(LANG['common.tips.submittedSuccessfully']);
      }
    });
  };

  // 获取分销商用户的分销订单信息
  @action
  getResellerOrders = (values, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/order/listResellerOrderByPage';
    httpRequest({
      url,
      method: 'POST',
      data: values,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  // 获取分销订单的商品信息
  getResellerOrderDetail = (params, callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/order/getResellerOrderDetail';
    httpRequest({
      url,
      params,
      instaToken: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data);
        }
      }
    });
  };

  @action
  getResellerFaq = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/meta/faq';
    httpRequest({
      url,
      language: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.questions);
        }
      }
    });
  };

  @action
  getResellerAgreement = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/meta/getUserAgreement';
    httpRequest({
      url,
      language: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.content);
        }
      }
    });
  };

  @action
  getResellerContact = (callback) => {
    const url = SERVER.API_SERVER_RESELLER + '/meta/getContactInfo';
    httpRequest({
      url,
      language: true,
    }).then((res) => {
      if (res.code === 0) {
        if (callback) {
          callback(res.data.content);
        }
      }
    });
  };

  @action
  getResellerUserTaxInfo = (cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/user/getResellerUserInfo';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      cb && cb(res?.data?.reseller_user_info || {});
    });
  };

  @action
  submitResellerUserInfo = (data, cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/user/submitResellerUserInfo';
    httpRequest({
      url,
      data,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      cb && cb(res);
    });
  };

  @action
  updateResellerUserInfo = (data, cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/user/updateResellerUserInfo';
    httpRequest({
      url,
      data,
      method: 'post',
      instaToken: true,
    }).then((res) => {
      cb && cb(res);
    });
  };

  // 获取分销商是否同意更新后的协议 信息。
  // resellerClauseState 初始：0 || 同意：1 || 不同意：2
  @action
  getResellerIsUpdateAgreement = (_, cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/meta/queryResellerClauseState';
    httpRequest({
      url,
      instaToken: true,
    }).then((res) => {
      this.isUpdateAgreement = res.data ? res.data.resellerClauseState : 0;
      cb && cb(res);
    });
  };

  // 更新分销商是否同意更新后的协议信息
  @action
  updateResellerIsUpdateAgreement = (data, cb) => {
    const url = SERVER.API_SERVER_RESELLER + '/meta/updateResellerClauseState';

    httpRequest({
      url,
      data,
      method: 'post',
      instaToken: true,
    }).then((res = {}) => {
      if (res.code === 0) {
        this.isUpdateAgreement = res.data.resellerClauseState;
      }
      cb && cb(res);
    });
  };
}

export default Reseller;
